<template>
  <div class="notification-grid">
    <profile-avatar
      :presetProfilePic="notification.notificationData.friend.profilePicture"
      :username="notification.notificationData.friend.username"
      :size="$vuetify.breakpoint.xs ? 32 : 48"
    ></profile-avatar>
    <div class="notification-message">
      <router-link :to="{ name: 'profile', params: { username: notification.notificationData.friend.username } }">{{
        notification.notificationData.friend.username
      }}</router-link>
      <br />
      wants to be your friend
      <br />
      <span class="notification-timestamp">
        {{ relativeDateString(new Date(notification.timeCreated).getTime()) }}
      </span>
    </div>
    <template
      v-if="notification.notificationData.requestStatus == FRIEND_REQUEST_STATUSES.APPROVED || friendRequestDenied"
    >
      <v-btn class="notification-action" color="primary" elevation="0" small disabled>{{
        friendRequestDenied ? "Declined" : "Accepted"
      }}</v-btn>
    </template>
    <template v-else>
      <v-btn class="notification-action" color="primary" elevation="0" small @click="acceptFriendRequest">Accept</v-btn>
      <v-btn class="notification-action" color="danger" outlined small @click="declineFriendRequest">Decline</v-btn>
    </template>
  </div>
</template>

<script>
/**
 * @typedef {Object} NewFriendRequestNotificationProp
 * @property {string} id - The notification id
 * @property {Object} notificationData
 * @property {string} notificationData.requestStatus
 * @property {Object} notificationData.friend
 */

import profileAvatar from "@/components/profile-avatar.vue";
import { FRIEND_REQUEST_STATUSES } from "../../util/constants";
import friends from "../../mixins/friends";
import { relativeDateString } from "../../util/dateHelpers";

export default {
  name: "friend-request-notification",

  props: {
    /**
     * @type {NewFriendRequestNotificationProp}
     */
    notification: Object,
  },

  components: { profileAvatar },

  mixins: [friends],

  computed: {
    requesterId() {
      return this.notification.notificationData.friend.id;
    },
  },

  data: () => ({
    FRIEND_REQUEST_STATUSES,

    friendRequestDenied: false,
  }),

  methods: {
    relativeDateString,

    async acceptFriendRequest() {
      await this.addFriendById(this.requesterId);
      this.$emit("friend-request-accepted");
    },

    async declineFriendRequest() {
      await this.removeFriendById(this.requesterId);
      this.friendRequestDenied = true;
    },
  },
};
</script>
